export const COMPANY_NAME = "IN VETERANS WE SERVE";
export const COMPANY_SHORT = "In Veterans We Serve";
export const COMPANY_INITIALS = "IVS";
export const COMPANY_ADDRESS_FULL = "1898 N Arrowhead Ave, Rialto, CA 92376";
export const COMPANY_LOCATION = "Rialto, CA";
export const COMPANY_REGION = "San Bernardino County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=1898%20N%20Arrowhead%20Ave%2C%20Rialto%2C%20CA%2092376";
export const HERO_IMAGE_URL = "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Focus", "value": "Veteran Benefits & Workforce" },
  { "label": "Structure", "value": "501(c)(3) Public Benefit Nonprofit" },
  { "label": "Location", "value": "Rialto, California" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "In Veterans We Serve" },
  { "label": "City & State", "value": "Rialto, CA" },
  { "label": "Service Area", "value": "San Bernardino County" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Benefits Awareness", "body": "We help veterans understand and access the benefits they have earned, including the Post-9/11 GI Bill, so no earned support goes unused." },
  { "icon": "✦", "title": "Education & Empowerment", "body": "We educate and support veterans to navigate their options with confidence and make the most of the resources available to them." },
  { "icon": "✿", "title": "Workforce Connections", "body": "We connect veterans with employers offering training and meaningful career pathways into civilian work." },
  { "icon": "❍", "title": "Employer Partnerships", "body": "We partner with employers who can access funding to provide veteran training and workforce opportunities at no cost to those they hire." },
];
